module.exports = __webpack_public_path__ + "img/my-account-black.ed3f176.svg";